function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "49.803,62.285 63.469,49.542 68.465,51.374 73.72,44.542 73.199,32.72 66.622,30.221 65.705,33.77  62.544,33.38 61.893,27.198 67.275,20.633 79.106,17.343 81.868,3.943 87.384,1.709 93.296,6.561 98.289,0 101.712,5.259  96.716,11.564 101.443,17.084 105.127,31.538 102.633,37.979 107.62,41.259 105.521,49.149 114.193,51.374 117.215,64.522  122.863,70.039 123.787,75.29 129.961,75.031 133.114,79.235 136.534,76.608 143.755,77.66 144.941,99.873 150.197,100.261  150.197,102.89 129.438,119.708 125.359,119.058 123.525,129.563 117.876,130.877 111.697,137.051 104.468,139.682 109.46,148.885  106.967,154.793 107.883,162.285 113.8,167.544 112.613,173.059 108.542,173.452 106.967,175.688 102.368,174.769 97.633,176.343  96.192,191.458 91.194,190.796 90.543,196.315 88.698,198.681 82.528,197.631 82.134,200 75.954,199.604 74.64,196.978  74.64,173.059 69.78,163.6 70.041,151.504 63.469,140.734 63.469,128.914 65.971,122.336 63.206,121.024 63.469,114.583  70.301,109.986 73.199,111.954 83.708,111.954 85.279,108.669 76.615,106.177 70.301,100.917 74.113,98.947 60.444,87.125  58.474,73.064 54.14,71.749 "
});

var Svg19 = function Svg19(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NL",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg19, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/19.9b766447.svg";
export { ForwardRef as ReactComponent };